// extracted by mini-css-extract-plugin
export default {"gameTitle":"TitleCard_gameTitle__IlEm2"};